import { ImpactLevel, ProbabilityLevel } from "@/types/risk-analysis";
import { ColoredDropdownOption } from "@/components/common/ColoredDropdown";

export const IMPACT_OPTIONS: ColoredDropdownOption<ImpactLevel>[] = [
  { value: "Scăzut", label: "Scăzut" },
  { value: "Mediu", label: "Mediu" },
  { value: "Ridicat", label: "Ridicat" },
];

export const PROBABILITY_OPTIONS: ColoredDropdownOption<ProbabilityLevel>[] = [
  { value: "Scăzută", label: "Scăzută" },
  { value: "Medie", label: "Medie" },
  { value: "Ridicată", label: "Ridicată" },
];
